export default {
  // Detalle público actualmente visible (micrositio)
  publicProductService: null,
  // Lista paginada para administración
  productsServicesList: [],
  productsServicesPagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 1,
  },
  // Producto en edición / selección
  selectedProductService: null,
  // Lista visible al miembro autenticado
  memberProductsServices: [],
};
